import React from 'react';
import './Shop.css';
import bell from '../assets/images/bell.png';
import support from '../assets/images/question-answer.png'
import gradientimage from '../assets/images//gradientimage.jpg'
import pythonscripts from '../assets/images/products/pythonautomationscripts.jpg'
import automationtools from '../assets/images/products/automationtools.jpg'
import modelassets from '../assets/images/products/3dassets.jpg'
import businesstools from '../assets/images/products/businesstools.jpg'
import hackersbundle from '../assets/images/products/hackersbundle.jpeg'
import datasets from '../assets/images/products/datasets.png'
import devopsautomationtools from '../assets/images/products/automatedevops.jpg'
import presentationtemplates from '../assets/images/products/presentationtemplates.jpg'
import studyplanners from '../assets/images/products/studyplanners.jpg'
import pyforsecurity from '../assets/images/products/pythonforsecurity.jpg'
import royalityfreemusic from '../assets/images/products/royalityfreemusic.jpg'
import bundle1 from '../assets/images/products/bundle1.jpeg'
import bundle2 from '../assets/images/products/bundle2.jpeg'
import bundle3 from '../assets/images/products/bundle3.jpeg'
import bundle4 from '../assets/images/products/bundle4.jpeg'
import bundle5 from '../assets/images/products/bundle5.jpeg'
import bundle6 from '../assets/images/products/bundle6.jpeg'
import bundle7 from '../assets/images/products/bundle7.jpeg'
import { Helmet } from 'react-helmet';

const scrollLeft = () => {
  const slider = document.getElementById('catalogSlider');
  slider.scrollBy({ left: -300, behavior: 'smooth' });
};

const scrollRight = () => {
  const slider = document.getElementById('catalogSlider');
  slider.scrollBy({ left: 300, behavior: 'smooth' });
};

function Shop() {
  return <div className='shop'>
    <Helmet>
      <title>Aadhaar Koul | Shop</title>
    </Helmet>
      <div className='shop-container'>
        <div className='options-container'>
          <div className='options12'>
            <a href=""><div><img src={support}></img></div></a>
            <a href=""><div><img src={bell}></img></div></a>
          </div>
        </div>
        <div className='top-scroll'></div>
        <div className='top-nav'>
          <a href='/shop'><div className='current-tab'>Assets</div></a>
          <a href='/shoproject'><div>Projects</div></a>
          <a href='/code'><div>IOT</div></a>
          <a href='/research'><div>Research</div></a>
          <a href='/books'><div>Books</div></a>
        </div>
        {/* <div className='title1'>
          <h2>Save 75% with Days of Code</h2>
        </div> */}
        <div className='banner'>
          <h2>Digital Assets</h2>
          <p>Explore the premium digital assets store to elevate your creative workflow.</p>
          <div>
          </div>
        </div>
        <div className='smaller-banner'>
            <h2>Curated Assets</h2>
            <p style={{width:'90%'}}>Explore expertly curated digital assets to accelerate your creative projects — from UI kits and templates to 3D models, AR/VR elements, and more.</p>
        <div>
        </div>
        </div>
        <div className='smaller-banner-text'>
          <div className='smaller-banner-text-content'>
            <h2>Save big with Days of Code</h2>
            <p>Avail up to 75% off on selected digital assets, tools, and resources — limited time only. 
            </p>
            <p>Offer Ends : 1st August , 2025</p>
            {/* <button>Find Out More</button> */}
          </div>
        </div>
        <div className='days-of-code'>
          <h2>Days of Code</h2>
          <h4>Save 75% with days of code</h4>
        </div>
        <div className='products'>
          <div className='products-catalog'>
            <div className='product'>
              <div className='product-image'>
                <img src={automationtools}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Automate Scripts</div>
                  <div><s>₹199</s> 75% off</div>
                  <div>₹49</div>
                  <a href='https://rzp.io/rzp/kOQi2ag' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={pythonscripts}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Python Scripts </div>
                  <div><s>₹236</s> 75% off</div>
                  <div>₹59</div>
                  <a href='https://rzp.io/rzp/fxuSMkX' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={modelassets}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>3D Assets</div>
                  <div><s>₹3999</s> 75% off</div>
                  <div>₹999</div>
                  <a href='https://rzp.io/rzp/6Qyv9qGR' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={businesstools}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Business Tools </div>
                  <div><s>₹236</s> 75% off</div>
                  <div>₹59</div>
                  <a href='https://rzp.io/rzp/Q74aEtQ8' ><button>View More</button></a>
                </div>
              </div>
            </div>
          </div>
          <div className='products-catalog'>
            <div className='product'>
              <div className='product-image'>
                <img src={hackersbundle}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Hacker's Bundle </div>
                  <div><s>₹800</s> 75% off</div>
                  <div>₹199</div>
                  <a href='https://rzp.io/rzp/mJ2KUDK3' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={datasets}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Dataset Bundle </div>
                  <div><s>₹800</s> 75% off</div>
                  <div>₹199</div>
                   <a href='https://rzp.io/rzp/sdP1xJkH' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={devopsautomationtools}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>Devops Tools </div>
                  <div><s>₹199</s> 75% off</div>
                  <div>₹59</div>
                  <a href='https://rzp.io/rzp/6gZjABJ' ><button>View More</button></a>
                </div>
              </div>
            </div>
            <div className='product'>
              <div className='product-image'>
                <img src={presentationtemplates}></img>
              </div>
              <div className='product-rate'>
                <div className='product-rate-contents'>
                  <div>PPt Templates </div>
                  <div><s>₹199</s> 75% off</div>
                  <div>₹59</div>
                  <a href='https://rzp.io/rzp/HVNnAfM' ><button>View More</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className='days-of-code'>
          <h2>Days of Code</h2>
          <h4>Save 75% with days of code</h4>
        </div>
        <div className='products2'>
          <button className="slide-btn left" onClick={() => scrollLeft()}>&#10094;</button>

          <div className='products2-catalog' id="catalogSlider">
            <a href='https://rzp.io/rzp/rfozlHvu'><div style={{ backgroundImage: `url(${bundle1})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹499</div></a>
            <a href='https://rzp.io/rzp/fJ06XIe'><div style={{ backgroundImage: `url(${bundle2})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹59</div></a>
            <a href='https://rzp.io/rzp/BIzUIu2s'><div style={{ backgroundImage: `url(${bundle3})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹59</div></a>
            <a href='https://rzp.io/rzp/zGjr7b3'><div style={{ backgroundImage: `url(${bundle4})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹249</div></a>
            <a href='https://rzp.io/rzp/YwwAhGF9'><div style={{ backgroundImage: `url(${bundle5})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹199</div></a>
            <a href='https://rzp.io/rzp/qQ1f29j'><div style={{ backgroundImage: `url(${bundle6})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹59</div></a>
            <a href='https://rzp.io/rzp/C2Bwxio'><div style={{ backgroundImage: `url(${bundle7})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }} className='product2'>₹299</div></a>
          </div>

          <button className="slide-btn right" onClick={() => scrollRight()}>&#10095;</button>
        </div>

        
        <div className='banner'>
          <h2>Request an Asset</h2>
          <p>Looking for a specific digital asset? Let us know what you need — whether it's a toolkit, template, or resource — and we'll do our best to make it available.</p>
          <div>
          <button>Send Request</button>
          </div>
        </div>
        <div className='title1'>
          <h6>*Requesting a digital asset may take up to one or two weeks, but rest assured — we’re committed to delivering exactly what you need.</h6>
        </div>
        <div className='title1'>
          <h5>Need help finding the right asset for your project?</h5>
          <h5>Get expert guidance on selecting and using digital resources.</h5>
          <h5>Reach out for personalized support and recommendations.</h5>
        </div>
      </div>
    </div>;
}

export default Shop;
